import React from 'react';
import styles from './TableHeaderContainer.module.scss';
import { Props } from './types';

const TableHeaderContainer = ({ children }: Props) => {
  return (
    <div className={styles.container}>
      {children}
    </div>
  );
};

export default TableHeaderContainer;
